import Icon from "@ant-design/icons";
import styled from "styled-components";
import { theme } from "../../../theme";

const IconForm = styled(Icon)<{ color?: string }>`
  & svg {
    fill: transparent;
    & *[fill="current"] {
      fill: ${({ color }) => color || theme.colors.gray4};
    }
    & *[stroke="current"] {
      stroke: ${({ color }) => color || theme.colors.gray4};
    }
  }
`;

export { IconForm };
